import React, { useMemo, useState } from 'react';
import { translate } from '@utils/i18n';
import { TabView } from '@ui/molecules/TabView/TabView';
import { SectionHeader } from '@ui/molecules/Header/SectionHeader';
import { Button } from '@ui';
import SprinklerProjectionTable from '../SprinklerProjection/SprinklerProjectionTable';
import SprinklerSamplingTable from '../SprinklerSampling/SprinklerSamplingTable';
import ContactDyneModal from '../SprinklerSampling/components/ContactDyneModal';
import KitOrderForm from '../SprinklerSampling/components/KitOrderForm';
import './BuildingSprinklerDashboardStyles.scss';
const NAMESPACE = 'analytic_reports.sprinkler_projection_report';
export default function BuildingSprinklerDashboard({ buildingId }) {
    const [isContactDyneOpen, setIsContactDyneOpen] = useState(false);
    const [isKitOrderOpen, setIsKitOrderOpen] = useState(false);
    const tabs = useMemo(() => [
        {
            id: 'sprinkler-projection',
            label: translate('tabs.sprinkler_projection', { namespace: NAMESPACE }),
            content: React.createElement(SprinklerProjectionTable, { buildingId: buildingId })
        },
        {
            id: 'sample-submissions',
            label: translate('tabs.sample_submissions', { namespace: NAMESPACE }),
            content: React.createElement(SprinklerSamplingTable, { buildingId: buildingId, showActions: false })
        }
    ], [buildingId]);
    return (React.createElement("div", { className: "building-sprinkler-dashboard" },
        React.createElement(SectionHeader, { title: translate('sprinkler_head_sampling', { namespace: NAMESPACE }), actions: React.createElement(React.Fragment, null,
                React.createElement(Button, { variant: "default", onClick: () => setIsContactDyneOpen(true) }, translate('contact_dyne', { namespace: NAMESPACE })),
                React.createElement(Button, { variant: "primary", onClick: () => setIsKitOrderOpen(true) }, translate('order_kits', { namespace: NAMESPACE }))) }),
        React.createElement("p", { className: "building-sprinkler-dashboard__subtitle" }, translate('intro', { namespace: NAMESPACE })),
        React.createElement(TabView, { tabs: tabs, defaultTabId: "sprinkler-projection" }),
        isContactDyneOpen && React.createElement(ContactDyneModal, { onClose: () => setIsContactDyneOpen(false) }),
        isKitOrderOpen && (React.createElement("div", { className: "sprinkler-sampling-container" },
            React.createElement(KitOrderForm, { buildingId: buildingId, isOpen: isKitOrderOpen, onClose: () => setIsKitOrderOpen(false) })))));
}
